module.exports = __webpack_public_path__ + "img/section-title3.4f68be8d.png";